import { useState } from 'react'
import api from '../services/api'
import FluxoProgresso from '../components/FluxoProgresso'

const STATUS = {
  aberto:     { label:'Aguardando atendimento', bg:'#E6F1FB', cor:'#185FA5' },
  tramitando: { label:'Em andamento',           bg:'#FAEEDA', cor:'#854F0B' },
  pendente:   { label:'Documentos pendentes',   bg:'#fef9c3', cor:'#854d0e' },
  concluido:  { label:'Concluído',              bg:'#EAF3DE', cor:'#3B6D11' },
  arquivado:  { label:'Arquivado',              bg:'#F1EFE8', cor:'#5F5E5A' },
}

function gerarCaptcha() {
  const a = Math.floor(Math.random() * 10) + 1
  const b = Math.floor(Math.random() * 10) + 1
  return { pergunta: `${a} + ${b}`, resposta: String(a + b) }
}

function formatarCPF(v) {
  return v.replace(/\D/g,'').replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d{1,2})$/,'$1-$2').slice(0,14)
}

export default function Consulta() {
  const [numero, setNumero] = useState('')
  const [cpf, setCpf] = useState('')
  const [captchaInput, setCaptchaInput] = useState('')
  const [captcha, setCaptcha] = useState(gerarCaptcha())
  const [resultado, setResultado] = useState(null)
  const [erro, setErro] = useState('')
  const [load, setLoad] = useState(false)

  async function consultar(e) {
    e.preventDefault()
    setErro(''); setResultado(null)

    if (captchaInput.trim() !== captcha.resposta) {
      setErro('Resposta do captcha incorreta.')
      setCaptcha(gerarCaptcha()); setCaptchaInput('')
      return
    }

    const cpfLimpo = cpf.replace(/\D/g,'')
    if (cpfLimpo.length < 11) { setErro('CPF inválido.'); return }

    setLoad(true)
    try {
      const numeroEnc = encodeURIComponent(numero.trim())
      const r = await api.get(`/processos/consulta-publica/${numeroEnc}`, { params: { cpf: cpfLimpo } })
      setResultado(r.data)
      setCaptcha(gerarCaptcha()); setCaptchaInput('')
    } catch(e) {
      setErro(e.response?.data?.erro || 'Processo não encontrado ou CPF não confere.')
      setCaptcha(gerarCaptcha()); setCaptchaInput('')
    } finally { setLoad(false) }
  }

  const st = resultado ? (STATUS[resultado.status] || STATUS.aberto) : null

  const inputStyle = {
    width: '100%', padding: '12px 14px',
    border: '1.5px solid #e5e7eb', borderRadius: 10,
    fontSize: 14, boxSizing: 'border-box',
    outline: 'none', fontFamily: 'inherit',
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0d3d6b 0%, #185FA5 50%, #1e7bc4 100%)',
      fontFamily: "'Inter', system-ui, sans-serif",
      padding: '32px 16px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Círculos decorativos */}
      <div style={{ position:'absolute', top:'-80px', right:'-80px', width:'320px', height:'320px', borderRadius:'50%', background:'rgba(255,255,255,0.05)', pointerEvents:'none' }} />
      <div style={{ position:'absolute', bottom:'-60px', left:'-60px', width:'240px', height:'240px', borderRadius:'50%', background:'rgba(255,255,255,0.04)', pointerEvents:'none' }} />

      <div style={{ maxWidth: 600, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        {/* Logo / cabeçalho */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 48, height: 48, borderRadius: 14,
            background: 'rgba(255,255,255,0.15)',
            backdropFilter: 'blur(8px)',
            marginBottom: 12,
            border: '1px solid rgba(255,255,255,0.2)',
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect x="2" y="2" width="9" height="9" rx="2" fill="white" fillOpacity="0.9"/>
              <rect x="13" y="2" width="9" height="9" rx="2" fill="white" fillOpacity="0.6"/>
              <rect x="2" y="13" width="9" height="9" rx="2" fill="white" fillOpacity="0.6"/>
              <rect x="13" y="13" width="9" height="9" rx="2" fill="white" fillOpacity="0.9"/>
            </svg>
          </div>
          <div style={{ fontSize: 26, fontWeight: 700, color: 'white', letterSpacing: '-0.5px' }}>
            Proto<span style={{ color: '#90c8f8' }}>Gov</span>
          </div>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.65)', marginTop: 4 }}>
            Consulta de protocolo
          </div>
        </div>

        {/* Card do formulário */}
        <div style={{
          background: 'white', borderRadius: 20,
          padding: '32px 28px', marginBottom: 16,
          boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
        }}>
          <div style={{ fontSize: 16, fontWeight: 600, color: '#111827', marginBottom: 4 }}>Acompanhar processo</div>
          <div style={{ fontSize: 13, color: '#9ca3af', marginBottom: 24 }}>Informe o número do protocolo e seu CPF para consultar o andamento.</div>

          <form onSubmit={consultar}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:600, marginBottom:6, color:'#374151', textTransform:'uppercase', letterSpacing:'0.5px' }}>Número do protocolo *</label>
              <input value={numero} onChange={e=>setNumero(e.target.value)} required placeholder="Ex: 2025/001.123"
                style={{ ...inputStyle, fontFamily:'monospace' }}
                onFocus={e=>e.target.style.borderColor='#185FA5'}
                onBlur={e=>e.target.style.borderColor='#e5e7eb'} />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:600, marginBottom:6, color:'#374151', textTransform:'uppercase', letterSpacing:'0.5px' }}>CPF do solicitante *</label>
              <input value={cpf} onChange={e=>setCpf(formatarCPF(e.target.value))} required placeholder="000.000.000-00"
                style={inputStyle}
                onFocus={e=>e.target.style.borderColor='#185FA5'}
                onBlur={e=>e.target.style.borderColor='#e5e7eb'} />
              <div style={{ fontSize:11, color:'#9ca3af', marginTop:4 }}>Só é possível consultar protocolos vinculados ao seu CPF.</div>
            </div>

            <div style={{ marginBottom: 24, background:'#f8fafc', borderRadius:12, padding:16, border:'1px solid #e5e7eb' }}>
              <div style={{ fontSize:12, fontWeight:600, marginBottom:10, color:'#374151', textTransform:'uppercase', letterSpacing:'0.5px' }}>Verificação de segurança</div>
              <div style={{ display:'flex', alignItems:'center', gap:12, flexWrap:'wrap' }}>
                <div style={{ background:'linear-gradient(135deg,#185FA5,#1e7bc4)', color:'white', padding:'10px 18px', borderRadius:10, fontSize:17, fontWeight:700, fontFamily:'monospace', letterSpacing:3, userSelect:'none', boxShadow:'0 4px 12px rgba(24,95,165,0.3)' }}>
                  {captcha.pergunta} = ?
                </div>
                <input value={captchaInput} onChange={e=>setCaptchaInput(e.target.value)} required placeholder="Resposta"
                  style={{ width:100, padding:'10px 12px', border:'1.5px solid #e5e7eb', borderRadius:10, fontSize:15, textAlign:'center', fontFamily:'inherit', outline:'none' }}
                  onFocus={e=>e.target.style.borderColor='#185FA5'}
                  onBlur={e=>e.target.style.borderColor='#e5e7eb'} />
                <button type="button" onClick={()=>{setCaptcha(gerarCaptcha());setCaptchaInput('')}}
                  style={{ padding:'10px 12px', border:'1.5px solid #e5e7eb', borderRadius:10, fontSize:14, cursor:'pointer', background:'white', color:'#6b7280' }}>
                  🔄
                </button>
              </div>
            </div>

            {erro && (
              <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:10, padding:'10px 14px', fontSize:13, color:'#dc2626', marginBottom:16, display:'flex', alignItems:'center', gap:8 }}>
                <span>⚠️</span> {erro}
              </div>
            )}

            <button type="submit" disabled={load}
              style={{ width:'100%', padding:'13px', background:load?'#93c5fd':'linear-gradient(135deg,#185FA5,#1e7bc4)', color:'white', border:'none', borderRadius:10, fontSize:15, cursor:load?'default':'pointer', fontWeight:600, boxShadow:load?'none':'0 4px 14px rgba(24,95,165,0.4)', fontFamily:'inherit' }}>
              {load ? 'Consultando...' : 'Consultar protocolo →'}
            </button>
          </form>
        </div>

        {resultado && (
          <div>
            <FluxoProgresso processo={resultado} />

            <div style={{ background:'white', borderRadius:20, border:'none', overflow:'hidden', boxShadow:'0 8px 32px rgba(0,0,0,0.12)' }}>
              <div style={{ padding:'20px 24px', borderBottom:'1px solid #f3f4f6' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start' }}>
                  <div>
                    <div style={{ fontFamily:'monospace', fontSize:14, color:'#185FA5', fontWeight:700 }}>{resultado.numero}</div>
                    <div style={{ fontSize:15, fontWeight:500, marginTop:4 }}>{resultado.assunto}</div>
                  </div>
                  <span style={{ background:st.bg, color:st.cor, padding:'4px 12px', borderRadius:99, fontSize:12, fontWeight:500, whiteSpace:'nowrap' }}>
                    {st.label}
                  </span>
                </div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12, marginTop:14 }}>
                  {[
                    ['Tipo', resultado.tipo_nome||'—'],
                    ['Aberto em', new Date(resultado.aberto_em).toLocaleDateString('pt-BR')],
                    ['Prazo', resultado.prazo_em ? new Date(resultado.prazo_em).toLocaleDateString('pt-BR') : '—'],
                    ['Setor atual', resultado.setor_atual_nome||'—'],
                  ].map(([l,v]) => (
                    <div key={l}><div style={{ fontSize:11, color:'#9ca3af' }}>{l}</div><div style={{ fontSize:13, fontWeight:500 }}>{v}</div></div>
                  ))}
                </div>
              </div>

              {resultado.tramitacoes?.length > 0 && (
                <div style={{ padding:20 }}>
                  <div style={{ fontSize:13, fontWeight:600, marginBottom:14, color:'#374151' }}>Andamento</div>
                  {resultado.tramitacoes.map((t,i,arr) => (
                    <div key={i} style={{ display:'flex', gap:12, paddingBottom:14, position:'relative' }}>
                      {i<arr.length-1 && <div style={{ position:'absolute', left:13, top:28, bottom:0, width:1, background:'#e5e7eb' }} />}
                      <div style={{ width:26, height:26, borderRadius:'50%', background:'#E6F1FB', border:'2px solid #B5D4F4', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, flexShrink:0 }}>
                        {i===arr.length-1?'●':'○'}
                      </div>
                      <div>
                        <div style={{ fontSize:13, color:'#111' }}>{t.descricao}</div>
                        <div style={{ fontSize:11, color:'#9ca3af', marginTop:2 }}>{new Date(t.data_hora).toLocaleString('pt-BR')}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        <div style={{ textAlign:'center', marginTop:24 }}>
          <a href="/" style={{ fontSize:13, color:'rgba(255,255,255,0.65)', textDecoration:'none' }}>← Voltar ao início</a>
        </div>
      </div>
    </div>
  )
}
